import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getErrorMessage } from "../../../utils/GeneralUtils";
import API from "../../api/API";
import useUser from "./useUser";
import { newToastEvent } from "../../../utils/ToastUtil";

const useDeleteAccountCredential = () => {
  const client = useQueryClient();
  const { user } = useUser();

  const deleteAccountCredential = useMutation({
    mutationFn: ({ accountID }: { accountID: string }) =>
      API.deleteAccountCredential(accountID),
    onSuccess: (_, { accountID }) => {
      // Update userAccounts react query cache so credential disapears from list.
      client.setQueryData(["userAccounts", user?.id], (prev) => {
        if (!prev || !Array.isArray(prev)) return prev;

        return prev.filter((c) => c?._id !== accountID);
      });

      newToastEvent("success", "Successfully removed account credential.");
    },
    onError: (e) => {
      newToastEvent("error", getErrorMessage(e));
    },
  });

  return {
    deleteAccountCredential: deleteAccountCredential.mutate,
    deletingCredential: deleteAccountCredential.isPending,
    deleteCredentialError: deleteAccountCredential.error
      ? getErrorMessage(deleteAccountCredential.error)
      : null,
  };
};

export default useDeleteAccountCredential;
